import React from "react";
import ReactDOM from "react-dom/client";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// The faces the design is set in, served from the bundle rather than from
// fonts.googleapis.com -- see the note in public/index.html.
// Inter is the template's own base face; its stylesheet @imports it from
// Google, which is disabled in public/assets/css/style.css.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/golos-text/400.css";
import "@fontsource/golos-text/500.css";
import "@fontsource/golos-text/600.css";
import "@fontsource/golos-text/700.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/800.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
// Registers the baked icon sets. Imported before ./App so that no component
// module can render an <Icon /> before the data is in place -- otherwise it
// would be looked up over the network.
import "./icons";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { bootstrapSession } from "./services/auth";

// Awaited before the first render on purpose. OneID sends the browser back to
// "/" with the ticket in the fragment, and "/" is behind the route guard -- if
// React rendered first, the guard would redirect to /sign-in and the ticket
// would be gone before anything could read it.
bootstrapSession().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <>
      <App />
    </>
  );
});

// The worker only caches the shell — /api/ and /ws/ pass straight through —
// so registering it in dev is safe and lets the install flow be tested on
// localhost.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // An unregistered worker just means no install prompt; never fatal.
    });
  });
}

reportWebVitals();
